import {BaseWebComponentRepository} from "../../../framework/BaseWebComponentRepository";
import {
  PhasrMonitoredRulesDetailsPanelDataProviderFactory
} from "../dataProvider/PhasrMonitoredRulesDetailsPanelDataProviderFactory";
import {PhasrMonitoredRulesDetailsPanelDataProvider} from "../dataProvider/PhasrMonitoredRulesDetailsPanelDataProvider";
import { IncidentData } from '../types';

export class PhasrMonitoredRulesDetailsPanelRepository extends BaseWebComponentRepository {
  public dataProviderFactory: PhasrMonitoredRulesDetailsPanelDataProviderFactory;
  public dataProvider: PhasrMonitoredRulesDetailsPanelDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new PhasrMonitoredRulesDetailsPanelDataProviderFactory(),
    });
  }

  public async getIncidentsByRuleId(page: number, ruleId: number, companyId: string): Promise<IncidentData[]> {
    return this.dataProvider.getIncidentsByRuleId(page, ruleId, companyId);
  }
}
